import { ApexOptions } from "apexcharts";
import { productChart, projectChart, saleChart } from "./WidgetsChartData";
import { DailyOrders, DailyRevenue, OrdersValue, TotalSell } from "../../Utils/Constants";

export const admissionRatioChart: ApexOptions = {
    series: [
        {
            name: '',
            data: [30, 29.31, 29.7, 29.7, 31.32, 31.65, 31.13, 29.8, 31.79, 31.67, 32.39, 30.63, 32.89, 31.99, 31.23, 31.57, 30.84, 31.07, 31.41, 31.17, 34, 34.50, 34.50, 32.53, 31.37, 32.43, 32.44, 30.2, 30.14, 30.65, 30.4, 30.65, 31.43, 31.89, 31.38, 30.64, 31.02, 30.33, 32.95, 31.89, 30.01, 30.88, 30.69, 30.58, 32.02, 32.14, 30.37, 30.51, 32.65, 32.64, 32.27, 32.1, 32.91, 30.65, 30.8, 31.92
            ],
        },
    ],
    chart: {
        type: 'area',
        height: 90,
        offsetY: -10,
        offsetX: 0,
        toolbar: {
            show: false,
        },
    },
    stroke: {
        width: 2,
        curve: 'smooth'
    },
    grid: {
        show: false,
        borderColor: 'var(--light)',
        padding: {
            top: 5,
            right: 0,
            bottom: -30,
            left: 0,
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0,
            opacityTo: 0,
            stops: [0, 0, 0]
        }
    },
    dataLabels: {
        enabled: false,
    },
    colors: ["var(--theme-default)"],
    xaxis: {
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        opposite: false,
        min: 29,
        max: 35,
        logBase: 100,
        tickAmount: 4,
        forceNiceScale: false,
        floating: false,
        decimalsInFloat: undefined,
        labels: {
            show: false,
            offsetX: -12,
            offsetY: -15,
            rotate: 0,
        },
    },
    legend: {
        horizontalAlign: 'left',
    },
};

export const orderValueChart: ApexOptions = {
    series: [
        {
            name: '',
            data: [30, 32.31, 31.47, 30.69, 29.32, 31.65, 31.13, 31.77, 31.79, 31.67, 32.39, 32.63, 32.89, 31.99, 31.23, 31.57, 30.84, 31.07, 31.41, 31.17, 32.37, 32.19, 32.51, 32.53, 31.37, 30.43, 30.44, 30.2,
                30.14, 30.65, 30.4, 30.65, 31.43, 31.89, 31.38, 30.64, 30.02, 30.33, 30.95, 31.89, 31.01, 30.88, 30.69, 30.58, 32.02, 32.14, 32.37, 32.51, 32.65, 32.64, 32.27, 32.1, 32.91, 33.65, 33.8, 33.92
            ],
        },
    ],
    chart: {
        type: 'area',
        height: 90,
        offsetY: -10,
        offsetX: 0,
        toolbar: {
            show: false,
        },
    },
    stroke: {
        width: 2,
        curve: 'smooth'
    },
    grid: {
        show: false,
        borderColor: 'var(--light)',
        padding: {
            top: 5,
            right: 0,
            bottom: -30,
            left: 0,
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 80, 100]
        }
    },
    dataLabels: {
        enabled: false,
    },
    colors: ["#e24175"],
    xaxis: {
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        opposite: false,
        min: 29,
        max: 35,
        logBase: 100,
        tickAmount: 4,
        forceNiceScale: false,
        floating: false,
        decimalsInFloat: undefined,
        labels: {
            show: false,
            offsetX: -12,
            offsetY: -15,
            rotate: 0,
        },
    },
    legend: {
        horizontalAlign: 'left',
    },
    responsive: [

    ],
};

export const dailyOrderChart: ApexOptions = {
    series: [
        {
            name: '',
            data: [30, 29.31, 29.7, 29.7, 31.32, 31.65, 31.13, 29.8, 31.79, 31.67, 32.39, 30.63, 32.89, 31.99, 31.23, 31.57, 30.84, 31.07, 31.41, 31.17, 34, 34.50, 34.50, 32.53, 31.37, 32.43, 32.44, 30.2,
                30.14, 30.65, 30.4, 30.65, 31.43, 31.89, 31.38, 30.64, 31.02, 30.33, 32.95, 31.89, 30.01, 30.88, 30.69, 30.58, 32.02, 32.14, 30.37, 30.51, 32.65, 32.64, 32.27, 32.1, 32.91, 30.65, 30.8, 31.92
            ],
        },
    ],
    chart: {
        type: 'area',
        height: 90,
        offsetY: -10,
        offsetX: 0,
        toolbar: {
            show: false,
        },
    },
    stroke: {
        width: 2,
        curve: 'smooth'
    },
    grid: {
        show: false,
        borderColor: 'var(--light)',
        padding: {
            top: 5,
            right: 0,
            bottom: -30,
            left: 0,
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100]
        }
    },
    dataLabels: {
        enabled: false,
    },
    colors: ['#D77748'],
    xaxis: {
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        opposite: false,
        min: 29,
        max: 35,
        logBase: 100,
        tickAmount: 4,
        forceNiceScale: false,
        floating: false,
        decimalsInFloat: undefined,
        labels: {
            show: false,
            offsetX: -12,
            offsetY: -15,
            rotate: 0,
        },
    },
    legend: {
        horizontalAlign: 'left',
    },
    responsive: [

    ],
};

export const dailyRevenueChart: ApexOptions = {
    series: [
        {
            name: '',
            data: [29, 30.31, 30.7, 31.69, 31.32, 31.65, 31.13, 31.77, 31.79, 31.67, 32.39, 32.63, 32.89, 31.99, 31.23, 31.57, 30.84, 31.07, 31.41, 31.17, 32.37, 32.19, 32.51, 32.53, 31.37, 30.43, 30.44, 30.2,
                30.14, 30.65, 30.4, 30.65, 31.43, 31.89, 31.38, 30.64, 30.02, 30.33, 30.95, 31.89, 31.01, 30.88, 30.69, 30.58, 32.02, 32.14, 32.37, 32.51, 32.65, 32.64, 32.27, 32.1, 32.91, 33.65, 33.8, 33.92
            ],
        },
    ],
    chart: {
        type: 'area',
        height: 90,
        offsetY: -10,
        offsetX: 0,
        toolbar: {
            show: false,
        },
    },
    stroke: {
        width: 2,
        curve: 'smooth'
    },
    grid: {
        show: false,
        borderColor: 'var(--light)',
        padding: {
            top: 5,
            right: 0,
            bottom: -30,
            left: 0,
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100]
        }
    },
    dataLabels: {
        enabled: false,
    },
    colors: ['#C95E9E'],
    xaxis: {
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        opposite: false,
        min: 29,
        max: 35,
        logBase: 100,
        tickAmount: 4,
        forceNiceScale: false,
        floating: false,
        decimalsInFloat: undefined,
        labels: {
            show: false,
            offsetX: -12,
            offsetY: -15,
            rotate: 0,
        },
    },
    legend: {
        horizontalAlign: 'left',
    },
    responsive: [

    ],
};


export const saleChartData = [
    {
        title: "Total Sale",
        amount: "$3654.00",
        description: "Compare to last month",
        percentage: "+65%",
        id: "chart-widget1",
        chart: saleChart
    },
    {
        title: "Total Project",
        amount: "12569",
        description: "Compare to last month",
        percentage: "+65%",
        id: "chart-widget2",
        chart: projectChart
    },
    {
        title: "Total Product",
        amount: "93M",
        description: "Compare to last month",
        percentage: "+65%",
        id: "chart-widget3",
        chart: productChart
    }
]

export const topSellData = [
    {
        class: "total-sells",
        title: TotalSell,
        image: "coin1.png",
        count: "12,463",
        icon: "fa-arrow-up",
        color: "success",
        percentage: "+ 20.08%",
        detail: "Compared to Jan 2024",
        chartId: "admissionRatio",
        chart: admissionRatioChart
    },
    {
        class: "total-sells-2",
        title: OrdersValue,
        image: "shopping1.png",
        count: "78,596",
        icon: "fa-arrow-down",
        color: "danger",
        percentage: "-   10.02%",
        detail: "Compared to Aug 2024",
        chartId: "order-value",
        chart: orderValueChart
    },
    {
        class: "total-sells-3",
        title: DailyOrders,
        image: "sent1.png",
        count: "95,789",
        icon: "fa-arrow-up",
        color: "success",
        percentage: "+ 13.23%",
        detail: "Compared to may 2024",
        chartId: "daily-value",
        chart: dailyOrderChart
    },
    {
        class: "total-sells-4",
        title: DailyRevenue,
        image: "sent1.png",
        count: "95,789",
        icon: "fa-arrow-down",
        color: "danger",
        percentage: "- 17.06%",
        detail: "Compared to july 2024",
        chartId: "daily-revenue",
        chart: dailyRevenueChart
    }
]

export const visitorChartData: ApexOptions = {
    series: [
        {
            name: "Active",
            data: [18, 50, 65, 18, 28, 70, 15, 35],
        },
        {
            name: "Bounce",
            data: [35, 70, 30, 60, 25, 45, 50, 50],
        },
    ],
    chart: {
        type: "bar",
        height: 220,
        toolbar: {
            show: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: "50%",
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        show: true,
        width: 6,
        colors: ["transparent"],
    },
    grid: {
        show: true,
        borderColor: "var(--chart-border)",
        xaxis: {
            lines: {
                show: true,
            },
        },
    },
    colors: ["#e24175", "var(--theme-default)"],
    xaxis: {
        categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon"],
        tickAmount: 4,
        tickPlacement: "between",
        labels: {
            style: {
                fontFamily: "Rubik, sans-serif",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        min: 0,
        max: 100,
        tickAmount: 5,
        labels: {
            style: {
                fontFamily: "Rubik, sans-serif",
            },
        },
    },
    fill: {
        opacity: 1,
    },
    legend: {
        position: "top",
        horizontalAlign: "left",
        fontFamily: "Rubik, sans-serif",
        fontSize: "14px",
        fontWeight: 500,
        labels: {
            colors: "var(--chart-text-color)",
        },
        
        itemMargin: {
            horizontal: 10,
        },
    },
    responsive: [
        {
            breakpoint: 1366,
            options: {
                plotOptions: {
                    bar: {
                        columnWidth: "80%",
                    },
                },
                grid: {
                    padding: {
                        right: 0,
                    },
                },
            },
        },
        {
            breakpoint: 1200,
            options: {
                plotOptions: {
                    bar: {
                        columnWidth: "50%",
                    },
                },
                grid: {
                    padding: {
                        right: 0,
                    },
                },
            },
        },
        {
            breakpoint: 576,
            options: {
                plotOptions: {
                    bar: {
                        columnWidth: "60%",
                    },
                },
                grid: {
                    padding: {
                        right: 5,
                    },
                },
            },
        },
    ],
};

export const generalGrowthChart: ApexOptions = {
    series: [{
        name: 'Growth',
        data: [22, 14, 23, 8, 14, 12, 2, 14, 18, 35, 18, 8, 24]
    }],
    chart: {
        height: 180,
        type: 'line',
        stacked: true,
        toolbar: {
            show: false
        },
        dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 5,
            left: 0,
            blur: 4,
            color: 'var(--theme-default)',
            opacity: 0.22
        },
    },
    grid: {
        show: true,
        borderColor: '#000000',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {
            lines: {
                show: false,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },

    colors: ["#5527FF"],
    stroke: {
        width: 3,
        curve: 'smooth'
    },
    xaxis: {
        type: 'category',
        categories: ['0', '', '10k', '', '20k', '', '30k', '', '40k', '', '50k', '', '60k', ''],
        tickAmount: 10,
        labels: {
            style: {
                fontFamily: 'Outfit, sans-serif',
                fontWeight: 500,
                colors: '#8D8D8D',
            },
        },
        axisTicks: {
            show: false
        },
        axisBorder: {
            show: false
        },
        tooltip: {
            enabled: false,
        },
    },
    fill: {
        type: 'gradient',
        gradient: {
            shade: 'dark',
            gradientToColors: ['#5527FF'],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            colorStops: [
                {
                    offset: 0,
                    color: "var(--theme-default)",
                    opacity: 1
                },
                {
                    offset: 100,
                    color: "#e24175",
                    opacity: 1
                },
            ]
        },
    },
    yaxis: {
        min: -10,
        max: 40,
        labels: {
            show: false
        }
    }
};